import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdminProvider } from './context/AdminContext';
import Dashboard from './pages/Dashboard';
import AddAnimal from './pages/AddAnimal';
import AnimalDetail from './pages/AnimalDetail';
import Incidents from './pages/Incidents';
import ReportIncident from './pages/ReportIncident';
import SocietyPolicy from './pages/SocietyPolicy';
import EmergencyResponse from './pages/EmergencyResponse';
import FeedingVolunteers from './pages/FeedingVolunteers';
import KnowledgeForum from './pages/KnowledgeForum';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import Layout from './components/Layout';
import './App.css';

function App() {
  return (
    <AdminProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/add" element={<AddAnimal />} />
                <Route path="/animal/:id" element={<AnimalDetail />} />
                <Route path="/incidents" element={<Incidents />} />
                <Route path="/report-incident" element={<ReportIncident />} />
                <Route path="/policy" element={<SocietyPolicy />} />
                <Route path="/emergency" element={<EmergencyResponse />} />
                <Route path="/feeding" element={<FeedingVolunteers />} />
                <Route path="/knowledge" element={<KnowledgeForum />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
    </AdminProvider>
  );
}

export default App;